import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";

const CountryDetails = ({
  selectedCountry,
  setSelectedCountry,
  openDetailsModal,
  setOpenDetailsModal,
}) => {
  const handleCloseDetailsModal = () => {
    setSelectedCountry({});
    setOpenDetailsModal(false);
  };

  return (
    <Modal
      show={openDetailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Country Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Row className="mb-3">
          {Object.entries({
            "Country Name": selectedCountry.country_name || "",
            "Country Code": selectedCountry.country_code || "",
            "ISO-3 Code": selectedCountry.iso3_code || "",
            "Numeric Code": selectedCountry.numeric_code || "",
            Capital: selectedCountry.capital || "",
            "Native Name": selectedCountry.native_name || "",
            Status: selectedCountry?.status ? "Active" : "In Active",
            "Created At":
              selectedCountry?.createdAt &&
              format(selectedCountry?.createdAt, "PP"),
            "Updated At":
              selectedCountry?.updatedAt &&
              format(selectedCountry?.updatedAt, "PP"),
            "Deleted At": selectedCountry?.deletedAt
              ? format(selectedCountry?.deletedAt, "PP")
              : "",
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span
                  className={`d-block fs-5 fw-medium ${!value && "text-danger"}`}
                >
                  {value || "N/A"}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default CountryDetails;
